// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { localCurrencySettings } from '../../../../../../utils/constans';

const TooltipTitle = ({
  amountBase = 0,
  amountVariable = 0,
  basicWorkType,
  variableWorkType,
  bidAmountBase = 0,
  bidAmountVariable = 0,
}) => {
  const isOriginalOffer =
    bidAmountBase === amountBase
    && (!bidAmountVariable || bidAmountVariable === amountVariable);

  const renderVariable = (amount, type) =>
    amount
      ? `${amount.toLocaleString('en-US', localCurrencySettings)} / ${type}`
      : 'None';

  if (isOriginalOffer) {
    return (
      <div className="tooltip-block">
        <div>
          {`Base ${amountBase.toLocaleString(
            'en-US',
            localCurrencySettings,
          )} / ${basicWorkType}`}
        </div>
        <div>
          {`Var: ${renderVariable(amountVariable, variableWorkType)}`}
        </div>
      </div>
    );
  }

  return (
    <div className="tooltip-block">
      <div className="tooltip-section-title">Counter Offer</div>
      <div>
        {`Base ${bidAmountBase.toLocaleString(
          'en-US',
          localCurrencySettings,
        )} / ${basicWorkType}`}
      </div>
      <div>
        {`Var: ${renderVariable(bidAmountVariable, variableWorkType)}`}
      </div>

      <div className="tooltip-divider" />

      <div className="tooltip-section-title">Original Offer</div>
      <div>
        {`Base ${amountBase.toLocaleString(
          'en-US',
          localCurrencySettings,
        )} / ${basicWorkType}`}
      </div>
      <div>
        {`Var: ${renderVariable(amountVariable, variableWorkType)}`}
      </div>
    </div>
  );
};

export default TooltipTitle;